angular.module('harriApp')
  .service('registrationApi', ['httpHelper', '$q', 'googleMaps', 'autoCompleteListTemplate', 'hUser', '$state', '$filter', 'coverAndProfileImagesOf',
    function(httpHelper, $q, googleMaps, autoCompleteListTemplate, hUser, $state, $filter, coverAndProfileImagesOf) {

      var registrationApi = {

        /**
         *
         * @param provider {String} 'linkedin' or 'facebook'
         * @param at access token
         * @returns {Promise}
         */
        socialRegistrationOrLogin: function(provider, at, register) {
          var defer = $q.defer();

          register = register? 'Register': 'Login';

          var requestPayload = {
            'access_token':at
          };

          var referrer_username = hUser.getUserNameReferral();
          if(referrer_username){
            requestPayload.referrer_username = referrer_username;
          }

          if( register ){
            var originalTrackingSourceData = ReferralUtils.getRefererSource();
            requestPayload = $.extend(requestPayload, originalTrackingSourceData);
          }

          httpHelper.put(provider + register,requestPayload).then(function(r) {

            if (r.data.status_code == 200) {

              r.data.data.social_login_type = provider;
              r.data.data.toekn = at;

              //test social login (when the user already has an account)
//                        r.data.data.social_login = false;

              hUser.updateUserData(r.data.data);

              defer.resolve(r);

            } else {
              defer.reject(r);
            }
          }, function(r) {
            defer.reject(r);
          });

          return defer.promise;
        },


        updateUserProfile: function() {
          return hUser.init();
        },

        getCusineLookup: function () {
          return httpHelper.getList('cusine', function(obj) {
            return {label: obj.name, value: obj.id};
          });
        },

        /**
         * Get list of all available timezones
         *
         * @returns {Function|promise|promise|promise|promise|promise|*}
         */
        getTimezonesLookup: function() {
          var defer = $q.defer();

          httpHelper.g('timezones', false).then(function(res) {
            if (res.data && res.data.status_code == 200) {
              defer.resolve(res.data.data);
            }
            else {
              defer.reject(res);
            }
          }, function(res){
            defer.reject(res);
          });

          return defer.promise;
        },

        getCategoriesLookup: function () {
              var defer = $q.defer();

              httpHelper.g('category_positions', false).then(function (r) {

                  //change the result to {label, value} results + suitable for search
                  if (r.data.status_code == 200) {

                      var categories = [];

                      _.each(r.data.data, function (group) {
                          categories.push({
                              name: $.trim(group.PositionType.name),
                              id: group.PositionType.id,
                              code: group.PositionType.code,
                              deleted: group.PositionType.deleted
                          });
                      });

                      defer.resolve(categories);

                  } else {
                      defer.reject(r);
                  }


              }, function (r) {
                  defer.reject(r);
              });

              return defer.promise;
          },

        getHecsLookup: function () {
          return httpHelper.getList('hecs', function(obj) {
            return {label: obj.name, value: obj.id};
          });
        },

        getUserSkills: function() {
          var defer = $q.defer();

          httpHelper.g('user_skills').then(function(d) {
            if(d.data.status_code == 200) {
              defer.resolve(d.data.data);
            } else {
              defer.reject(d);
            }
          }, function(d) {
            defer.reject(d);
          });

          return defer.promise;
        },
        getSkillLookup: function () {
          var defer = $q.defer();

            if (hUser.isLoggedIn()) {
                httpHelper.g('latest_position').then((r) => {
                    const position = r.data.data;

                    if (r.data.status_code === 200 && position.position_id) {
                        getSkills(position.position_id);
                    } else {
                        getSkills();
                    }
                }).catch(() => {
                    getSkills();
                });
            } else {
                getSkills();
            }

          function getSkills(postionId) {

            var skillsPromise = JobAPI.getSkills(postionId);
            if(!skillsPromise) {
              defer.resolve([]);
            }

            skillsPromise.then(function (skills) {

              var skillsList = [];

              // load options
              _.each(skills.data.data, function (skillsGroup, skill_code) {

                if (skill_code != 'POPULAR') {
                  if(skillsGroup.items) {
                    _.each(skillsGroup.items, function (skill) {
                      skillsList.push({name: skill.name, skill_group: $filter("translate")("Additional Skills to Choose From"), id: skill.id});
                    });
                  }
                }

              });

              // push Recommended Skills to the first of the array
              var skillsGroup = skills.data.data['POPULAR'];
              if(skillsGroup) {
                if(skillsGroup.items) {
                  _.each(skillsGroup.items, function (skill) {
                    skillsList.unshift({name: skill.name, skill_group: $filter("translate")("Suggested Skills for Your Position"), id: skill.id});
                  });
                }
              }

              defer.resolve(skillsList);

            }, function(r) {
              defer.reject(r);
            });

          }

          return defer.promise;
        },

        getAvailabilityOptions: function () {

          var options = [
            'weekend_days',
            'weekend_nights',
            'weeknights',
            'weekdays'
          ];

          return options;

        },

        getAvailabilitySubOptions: function () {
          var subOptions = {};

          subOptions.weekdays = [
            'monday_morning',
            'tuesday_morning',
            'wednesday_morning',
            'thursday_morning',
            'friday_morning',
            'friday_afternoon',
            'thursday_afternoon',
            'wednesday_afternoon',
            'tuesday_afternoon',
            'monday_afternoon'
          ];

          subOptions.weeknights = [
            'monday_evening',
            'tuesday_evening',
            'wednesday_evening',
            'thursday_evening',
            'friday_evening'
          ];

          subOptions.weekend_days = [
            'saturday_morning',
            'sunday_morning',
            'saturday_afternoon',
            'sunday_afternoon'
          ];

          subOptions.weekend_nights = [
            'saturday_evening',
            'sunday_evening'
          ];


          subOptions.morning = [
            'sunday_morning',
            'monday_morning',
            'tuesday_morning',
            'wednesday_morning',
            'thursday_morning',
            'friday_morning',
            'saturday_morning'
          ];

          subOptions.afternoon = [
            'saturday_afternoon',
            'friday_afternoon',
            'thursday_afternoon',
            'wednesday_afternoon',
            'tuesday_afternoon',
            'monday_afternoon',
            'sunday_afternoon'
          ];

          subOptions.evening = [
            'sunday_evening',
            'monday_evening',
            'tuesday_evening',
            'wednesday_evening',
            'thursday_evening',
            'friday_evening',
            'saturday_evening'
          ];

          return subOptions;
        },

        brandSearch: function(str) {

          var defer = $q.defer();
          httpHelper.g( 'brand/search/' + encodeURI(str), true).then(function(response) {

            if (response.data.status_code == 200) {

              var serverBrands = [];

              _.each(response.data.data, function (brand) {
                brand = brand.Brand;
                _.each(brand.Location, function (location) {
                  serverBrands.push({
                    label: autoCompleteListTemplate({name: brand.name, address: location.formatted_address}),
                    value: {"brand_id": brand.id, "location_id": location.id }
                  })
                });
              });

              defer.resolve(serverBrands);

            } else {
              defer.reject(response);
            }

          }, function(response) {
            defer.reject(response);
          });

          return defer.promise;
        },

        //hold the last keyword of search into this variable to show the last & matched result
        searchKeyword:'',

        ServerAndGooglePlaceBatchSearchWithPriorityToServer: function(str) {
          //assign the latest search value into searchKeyword shared value
          registrationApi.searchKeyword = str;

          var defer = $q.defer();

          if(!str) {
            defer.resolve([]);
            return defer.promise;
          }

//                var serverSearch = registrationApi.brandSearch(str);
          var placeSearch = googleMaps.placeAutocomplete(str);

          $q.all({placeSearch:placeSearch}).then(function(response) {

            if(registrationApi.searchKeyword != str) {
              defer.reject();
            }
            var uniqueResponses = [];

            //find unique responses by label value, make priority to Harri's result
            for(var k in response.placeSearch) {
              var result = response.placeSearch[k];
              result.type = 'Google';
              result.order = k;
              uniqueResponses[result.label] = result;
            }

            //Harri's Result | Overwrite Google results
//                    for(var k in response.serverSearch) {
//                        var result = response.serverSearch[k];
//                        result.type = 'Harri';
//
//                        //keep server order
//                        result.order = k;
//                        uniqueResponses[result.label] = result;
//                    }


            //covert the unique result into array
            var uniqueResponsesArray = [];
            for(var k in uniqueResponses) {
              uniqueResponsesArray.push(uniqueResponses[k]);
            }

            //show Harri's result at top.
            uniqueResponsesArray = _.sortBy(uniqueResponsesArray, function(result) {
              var order = parseInt(result.order);

              //order Google's search result based on their order + put them after server result
              if(result.type == 'Google') {
                order = order + uniqueResponsesArray.length;
              }
              return order;
            });

            defer.resolve(uniqueResponsesArray);
          }, function(r) {
            defer.reject(r);
          });

          return defer.promise;
        },



        SearchGooglePlaceForInstitutes: function(str) {
          var defer = $q.defer();

          if(!str) {
            defer.resolve([]);
            return defer.promise;
          }

          var placeSearch = googleMaps.placeAutocomplete(str);

          $q.all({placeSearch:placeSearch}).then(function(response) {
            var searchResult = [];

            //find unique responses by label value, make priority to Harri's result
            for(var k in response.placeSearch) {
              var result = response.placeSearch[k];
              result.type = 'Google';
              result.order = k;
              searchResult.push(result);
            }

            defer.resolve(searchResult);
          }, function(r) {
            defer.reject(r);
          });

          return defer.promise;
        },


        workHistoryQueue: [],
        getWorkHistoryFromQueue: function() {

          var defer = $q.defer();

          //return one element + the count of all work histories
          function returnLatestPosition() {
            defer.resolve({workHistory: registrationApi.workHistoryQueue.shift(), remains: registrationApi.workHistoryQueue.length});
          }

          if(registrationApi.workHistoryQueue.length > 0) {
            returnLatestPosition();
          } else {
            //load work history if not loaded
            httpHelper.g('work_history').then(function (response) {
              for(var k in response.data.data) {
                //find cover image
                var basicBrandMedia = coverAndProfileImagesOf(response.data.data[k].Work.Brand.BrandMedia);
                response.data.data[k].Work.Brand.cover = basicBrandMedia.cover;
                response.data.data[k].index = k;
              }
              registrationApi.workHistoryQueue = response.data.data;

              returnLatestPosition();
            });
          }

          return defer.promise;
        },

        institution_search: function(str) {
          var q = $q.defer();

          httpHelper.p('institution_search', {"institution_name_criteria" : "%" + str + "%"}, undefined, undefined,true).then(function(r) {

            if(r.data.status_code == 200) {
              var data = [];

              for (var k in r.data.data) {
                data.push({
                  label: autoCompleteListTemplate({name: r.data.data[k].name, address: r.data.data[k].address}),
                  value: {institution_id: r.data.data[k].id}
                });
              }

              q.resolve(data);

              //reject
            } else {
              q.reject(r);
            }
            //reject
          }, function() { q.reject(r); });

          return q.promise;
        },

        educationQueue: [],
        getEducationFromQueue: function() {

          var defer = $q.defer();

          //return one element + the count of all work histories
          function returnLatestEducation() {
            defer.resolve({education: registrationApi.educationQueue.shift(), remains: registrationApi.educationQueue.length});
          }

          if(registrationApi.educationQueue.length > 0) {
            returnLatestEducation();
          } else {
            //load education if not loaded
            var userId = hUser.data.user.id;
            httpHelper.g('user_education/' + userId).then(function (response) {
              registrationApi.educationQueue = response.data.data;

              returnLatestEducation();
            });
          }

          return defer.promise;
        },


        getBrandLocation: function(brand_id) {
          var d = $q.defer();
          httpHelper.g('brand/location/' + brand_id).then(function (r) {
            if (r.data.status_code == 200) {
              d.resolve(r.data.data);
            } else {
              d.reject(r);
            }
          }, function(r) {
            d.reject(r);
          });
          return d.promise;
        },

        //brand media
        getBrandGallery: function(brandId, slug) {
          var d = $q.defer();

          httpHelper.g('profile/media?type=brand&item_id=' + brandId + '&image_offset=0&video_offset=0').then(function (res) {
            if (res.data.status_code == 200) {
              var result = [];

              var images = res.data.data.image_gallery || [];

              images.forEach(function(image) {
                image.absUrl = $filter('getUserMediaUrl')(image.uuid, slug);
                result.push(image);
              });

              var videos = res.data.data.video_gallery || [];

              videos.forEach(function(video) {
                video.absUrl = $filter('getUserMediaUrl')(video.uuid, slug);
                result.push(video);
              });

              d.resolve(result);
            } else {
              d.reject(res);
            }
          }, function(error) {
            d.reject(error);
          });
          return d.promise;
        },

        getBrandBasicPhotos: function(brand_id, slug) {
          var d = $q.defer();

          httpHelper.g('brand/basic_media/' + brand_id).then(function(r) {
            if (r.data.status_code == 200) {
              var brandBasicPhotos = {};
              brandBasicPhotos.cover = r.data.data.brand_background;
              brandBasicPhotos.cover.absUrl = $filter('getUserMediaUrl')(brandBasicPhotos.cover.uuid, slug);

              brandBasicPhotos.icon = r.data.data.brand_profile;
              brandBasicPhotos.icon.absUrl = $filter('getUserMediaUrl')(brandBasicPhotos.icon.uuid, slug);

              brandBasicPhotos.brand_offer_header = r.data.data.brand_offer_header;
              brandBasicPhotos.brand_offer_header.absUrl = $filter('getUserMediaUrl')(brandBasicPhotos.brand_offer_header.uuid, slug);

              d.resolve(brandBasicPhotos);
            } else {
              d.reject(r);
            }
          }, function(r) {
            d.reject(r);
          });

          return d.promise;
        },

        generateBrandPhoto: function(uuid, type, slug) {

          if( !isNaN(slug) ){
            return {uuid:uuid, path:slug, type:type, absUrl: $filter('getUserMediaUrl')(uuid, slug)};
          }
          else{
            // TODO: path should not be equal to uuid
            return {uuid:uuid, path:uuid, type:type, absUrl: $filter('getUserMediaUrl')(uuid, slug)};
          }
        },

        removeBrandGallery: function(uuid) {
          return httpHelper.d('delete_brand_media/'+uuid);
        },

        updateBrandMediaDetails: function(imageObj) {
          if(!imageObj.title && !imageObj.description) {
            var defer = $q.defer();
            defer.resolve({});
            return defer.promise;
          }
          return httpHelper.p('brand_media_details', {"image_uuid": imageObj.uuid, "title" : imageObj.title, "description": imageObj.description})
        },

        brandHostedVideoLink: function(url, brand_id, slug) {
          return httpHelper.put('brand_hosted_video', {url: url, brand_id:brand_id});
        },





        //user media
        user_gallery: function() {
          var d = $q.defer();
          var userId = hUser.data.user.id;
          httpHelper.g('user_gallery/' + userId).then(function (r) {
            if (r.data.status_code == 200) {
              //photo url
              for(var k in r.data.data.gallery) {
                r.data.data.gallery[k].absUrl = $filter('getUserMediaUrl')(r.data.data.gallery[k].uuid);
              }

              d.resolve(r.data.data);
            } else {
              d.reject(r);
            }
          }, function(r) {
            d.reject(r);
          });
          return d.promise;
        },

        generateUserPhoto: function(uuid, type, userid) {
          if( userid ){
            return {uuid:uuid, path:userid, type:type, absUrl: $filter('getUserMediaUrl')(uuid)};
          }
          else{
            return {uuid:uuid, path:uuid, type:type, absUrl: $filter('getUserMediaUrl')(uuid)};
          }
        },

        getUserBasicPhotos: function() {
          var d = $q.defer();

          httpHelper.g('user/basic_media').then(function(r) {
            if (r.data.status_code == 200) {
              var userBasicPhotos = {};
              userBasicPhotos.cover = r.data.data.user_background;
              userBasicPhotos.cover.absUrl = $filter('getUserMediaUrl')(userBasicPhotos.cover.uuid);

              userBasicPhotos.icon = r.data.data.user_profile;
              userBasicPhotos.icon.absUrl = $filter('getUserMediaUrl')(userBasicPhotos.icon.uuid);

              d.resolve(userBasicPhotos);
            } else {
              d.reject(r);
            }
          }, function(r) {
            d.reject(r);
          });

          return d.promise;
        },

        removeUserGallery: function(uuid) {
          return httpHelper.d('delete_user_media/'+uuid);
        },

        updateUserMediaDetails: function(imageObj) {
          return httpHelper.p('user_media_details', {"image_uuid": imageObj.uuid, "title" : imageObj.title, "description": imageObj.description})
        },

        userHostedVideoLink: function(url) {
          return httpHelper.put('hosted_video', {url: url});
        },








        //Locations
        addUserLocations: function(locations) {
          var googleLocations = {"user_location": []};

          for(var k in locations) {
            var location = locations[k];
            googleLocations.user_location.push({"google_location": location, "is_primary": false});
          }

          return httpHelper.p('user/time_geography', googleLocations);
        },

        addBrandLocations: function(locations, brand_id) {
          var defer = $q.defer();

          var promises = [];

          for(var k in locations) {
            var location = locations[k];
            promises.push(
              httpHelper.put('brand/location', {"google_location": location, "brand_id": brand_id})
            );
          }

          $q.all(promises).then(function(r) {
            defer.resolve(r);
          }, function() {

          })

          return defer.promise;
        },


        getBrandLocations: function(brand_id) {
          return httpHelper.g('brand/location/' + brand_id);
        }




      };

      return registrationApi;
    }]);
